/**
 * Import required libraries
 */
import React, { useMemo } from "react";
import { useHistory, useLocation } from "react-router";
import { hasRight } from "Utils";

/**
 * Import required elements
 */
// Material-ui components
import {
  Drawer,
  MenuList,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Badge
} from "@material-ui/core";

import styles from "./styles";
import labels from "./labels";

/**
 * NavMenu Render JSX
 */
const NavMenu = props => {
  const location = useLocation();
  const history = useHistory();

  let { lang, navmenu, onClose, items } = props;
  //console.log("items :",items)

  // CSS classnames
  const classes = styles(props);

  let selected = useMemo(() => {
    return location.pathname.split("/").find(k => {
      return items.find(({ key }) => k === key);
    });
  }, [items, location.pathname])

  return (
    <Drawer
      className={classes.drawer}
      classes={{ paper: classes.drawerPaper }}
      open={navmenu.open}
      variant={navmenu.variant}
      onClose={onClose}
    >
      <MenuList>
        {items.reduce((acc, { key, profile, icon, additional_clue }) => {
          if (!hasRight(profile)) return acc;
          else return [
            ...acc,
            <div className={classes.boxlayout} key={key}>
              <MenuItem
                key={key}
                className={classes.item}
                selected={selected === key}
                onClick={e => history.push(`/${key}`)}
              >
                <ListItemIcon className={classes.icon}>{icon}</ListItemIcon>
                <ListItemText
                  classes={{ primary: classes.label }}
                  primary={labels[key][lang]}
                />
              </MenuItem>
              
              {additional_clue != null && 
                <MenuItem 
                  className={classes.badge}
                  onClick={e => history.push(`/${additional_clue.path}`)}>
                  <ListItemIcon>
                    <Badge badgeContent={additional_clue.info} color="error" />
                  </ListItemIcon>
                </MenuItem>
              }
            </div>
          ];
        }, [])}
      </MenuList>
    </Drawer>
  );
};

export default NavMenu;
